import React, { useState, useEffect } from 'react';
import { fetchVideo } from './api';
import { useTranslations } from '../ArticleFormNew/contexts/TranslationContext';

export default function VideoPreviewModal({ videoId, onClose }) {
  var t = useTranslations();
  var loadingState = useState(true);
  var loading = loadingState[0];
  var setLoading = loadingState[1];

  var videoState = useState(null);
  var video = videoState[0];
  var setVideo = videoState[1];

  var tabState = useState('id');
  var activeTab = tabState[0];
  var setActiveTab = tabState[1];

  useEffect(function() {
    fetchVideo(videoId)
      .then(function(data) { setVideo(data); setLoading(false); })
      .catch(function() { setLoading(false); });
  }, [videoId]);

  useEffect(function() {
    function handleKey(e) { if (e.key === 'Escape') onClose(); }
    document.addEventListener('keydown', handleKey);
    return function() { document.removeEventListener('keydown', handleKey); };
  }, [onClose]);

  useEffect(function() {
    document.body.style.overflow = 'hidden';
    return function() { document.body.style.overflow = ''; };
  }, []);

  var hasEnglish = video && video.content_en;
  var hasSeo = video && (video.meta_description || video.meta_keywords);
  var hasTags = video && video.tag_list && video.tag_list.length > 0;
  var hasCategories = video && video.category_list && video.category_list.length > 0;

  return (
    <div className="preview-modal__overlay" onClick={onClose}>
      <div className="preview-modal" onClick={function(e) { e.stopPropagation(); }}>
        <div className="preview-modal__header">
          <h5>{t.preview || 'Preview'}</h5>
          <button type="button" className="preview-modal__close" onClick={onClose}>
            <i className="zmdi zmdi-close" />
          </button>
        </div>

        <div className="preview-modal__body">
          {loading && (
            <div className="preview-modal__empty">
              <span className="spinner-border spinner-border-sm me-2" />
              Loading...
            </div>
          )}

          {!loading && !video && (
            <div className="preview-modal__empty">Video not found</div>
          )}

          {!loading && video && (
            <div className="preview-modal__article">
              {video.thumbnail_url && (
                <div className="preview-modal__cover">
                  <img src={video.thumbnail_url} alt="" />
                  <div className="preview-modal__cover-overlay" />
                </div>
              )}

              <div className="preview-modal__info">
                <div className="preview-modal__top-row">
                  <span className="preview-modal__status-badge preview-modal__status-badge--draft">
                    {t.draft}
                  </span>
                  {video.video_url && (
                    <span className="preview-modal__reading-time">
                      <i className="zmdi zmdi-videocam" /> Video
                    </span>
                  )}
                </div>

                <h2 className="preview-modal__title">{video.title_id}</h2>
                {video.title_en && <p className="preview-modal__title-en">{video.title_en}</p>}

                {video.video_url && (
                  <div className="mb-3">
                    <a href={video.video_url} target="_blank" rel="noopener noreferrer" className="text-primary">
                      <i className="zmdi zmdi-open-in-new me-1" />{video.video_url}
                    </a>
                  </div>
                )}

                <div className="preview-modal__meta">
                  {video.hospital_name && (
                    <span className="preview-modal__meta-item"><i className="zmdi zmdi-hospital" /> {video.hospital_name}</span>
                  )}
                  {video.doctor_names && video.doctor_names.length > 0 && (
                    <span className="preview-modal__meta-item"><i className="zmdi zmdi-account" /> {video.doctor_names.join(', ')}</span>
                  )}
                  {video.created_at && (
                    <span className="preview-modal__meta-item"><i className="zmdi zmdi-calendar" /> {new Date(video.created_at).toLocaleDateString()}</span>
                  )}
                </div>

                {(hasTags || hasCategories) && (
                  <div className="preview-modal__taxonomies">
                    {hasTags && video.tag_list.map(function(tag) { return <span key={tag} className="preview-modal__tag">{tag}</span>; })}
                    {hasCategories && video.category_list.map(function(cat) { return <span key={cat} className="preview-modal__category">{cat}</span>; })}
                  </div>
                )}

                <div className="preview-modal__divider" />

                {hasEnglish ? (
                  <div>
                    <div className="preview-modal__tabs">
                      <button type="button" className={'preview-modal__tab' + (activeTab === 'id' ? ' preview-modal__tab--active' : '')} onClick={function() { setActiveTab('id'); }}>{t.tab_indonesian}</button>
                      <button type="button" className={'preview-modal__tab' + (activeTab === 'en' ? ' preview-modal__tab--active' : '')} onClick={function() { setActiveTab('en'); }}>{t.tab_english}</button>
                    </div>
                    <div className="preview-modal__content" dangerouslySetInnerHTML={{ __html: activeTab === 'id' ? (video.content_id || '<p class="text-muted">-</p>') : video.content_en }} />
                  </div>
                ) : (
                  <div className="preview-modal__content" dangerouslySetInnerHTML={{ __html: video.content_id || '<p class="text-muted">-</p>' }} />
                )}

                {hasSeo && (
                  <div className="preview-modal__seo">
                    <h6 className="preview-modal__seo-title"><i className="zmdi zmdi-search" /> {t.seo}</h6>
                    {video.meta_description && (
                      <div className="preview-modal__seo-field">
                        <span className="preview-modal__seo-label">{t.meta_description}</span>
                        <p className="preview-modal__seo-value">{video.meta_description}</p>
                      </div>
                    )}
                    {video.meta_keywords && (
                      <div className="preview-modal__seo-field">
                        <span className="preview-modal__seo-label">{t.meta_keywords}</span>
                        <p className="preview-modal__seo-value">{video.meta_keywords}</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
